export default "__VITE_ASSET__BxPzU7yE__"